import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=049c0394&scoped=true&"
import script from "./ProjectBoard.vue?vue&type=script&lang=js&"
export * from "./ProjectBoard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=049c0394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c0394",
  null
  
)

export default component.exports